<template>
	<modal ref="modal">
		<template #title>{{action.toUpperCase()}} MARKETING VIDEO</template>
		<template #body>
			<div class="form-floating mb-4">
				<select v-model="form.category" id="category" name="category" class="form-control" placeholder="Category">
					<option value="SILVER">SILVER</option>
					<option value="GOLD">GOLD</option>
					<option value="DIAMOND">DIAMOND</option>
					<option value="PLATINUM">PLATINUM</option>
					<option value="PLATINUM COUPLE">PLATINUM COUPLE</option>
					<option value="PLATINUM FAITHFUL">PLATINUM FAITHFUL</option>
				</select>
				<label class="form-label" for="category">Category</label>
			</div>
			<div class="form-floating mb-4">
				<input v-model="form.title" type="text" id="title" name="title" class="form-control" placeholder="Title" />
				<label class="form-label" for="title">Title</label>
			</div>
			<div class="form-floating mb-4">
				<input v-model="form.description" type="text" id="description" name="description" class="form-control" placeholder="Description" />
				<label class="form-label" for="description">Description</label>
			</div>
			<div class="form-floating mb-4">
				<input v-model="form.video_id" type="text" id="video_id" name="video_id" class="form-control" placeholder="Video ID" />
				<label class="form-label" for="video_id">Video ID</label>
			</div>
			<div class="form-floating mb-4">
				<input v-model="form.download_link" type="text" id="download_link" name="download_link" class="form-control"  placeholder="Download Link"/>
				<label class="form-label" for="download_link">Download Link</label>
			</div>
			
			<div class="form-floating mb-4">
				<select v-model="form.status" id="status" name="status" class="form-control" placeholder="Status">
                  <option value="1">ON</option>
                  <option value="0">OFF</option>
                </select>
				<label class="form-label" for="status">Status</label>
			</div>

		</template>
		<template #footer>
			<button 
				@click="actionContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Add</span><span v-else>Update</span> Marketing Video</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}
		
		const action = ref('add');

		const form = useForm({
			id 				: 0,
			category 		: '',
			title 			: '',
			description 	: '',
			video_id 		: '',
			download_link 	: '',
			status 			: '0'
		})

		const actionContent = ()=>{

			if(action.value=='add')
			{
				addMarketingVideo();
			}else
			{
				updateMarketingVideo();	
			}

		}

		const addMarketingVideo = () => {
			form.post(route('admin.affiliate-program.post-marketing-video'), {
				preserveState: true,
				preserveScroll: true,
				only:['marketingVideos,api_response','search'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const updateMarketingVideo = () => {
			form.put('marketing-video/'+form.id, {
				preserveState: true,
				preserveScroll: true,
				only:['marketingVideos,api_response','search'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const setMarketingVideoContent = (_action,data)=>{
								
								form.reset();

								action.value = _action;

								if(_action=='update')
								{
									form.id 			= data.id;
									form.category 		= data.category;
									form.title 			= data.title;
									form.description 	= data.description;
									form.video_id 		= data.video_id;
									form.download_link 	= data.download_link;
									form.status 		= data.status;
								}
								
							}


		return {
			form,
			modal,
			toggleModal,
			action,
			setMarketingVideoContent,
			actionContent,
			addMarketingVideo,
			updateMarketingVideo,
		}
	},
}
</script>
